<template>
    <div class="elder-transfer">
        <mt-header fixed title="老人转出申请">
            <router-link :to="'/elder/'+id" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <mt-field label="转出对象" v-model="elder_name" disabled></mt-field>
            <mint-select selectLabel="*转入服务点" selectPatch="station" :selectValue="station" :slots="stationSlots" @changeValue="changeValue"></mint-select>
            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="updateElder">提交申请</mt-button>
            </div>
        </div>
    </div>
</template>
<script>

    import mintSelect from '../../components/mintSelect.vue'
    export default{

        components:{
            'mint-select':mintSelect
        },


        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                id:this.$route.params.id,
                elder_name:'',

                station:'',
                stationSlots:[
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

            }
        },

        methods:{

            updateElder(){

                this.$indicator.open('加载中');

                this.$axios.post("/elder/transfer", {openid:this.openid,elder:this.id,station:this.station})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('申请成功,已向对方服务点发出申请!');
                            this.$router.push('/my/transfer')
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            },

            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            }
        },

        created(){
            this.$axios.get('/elder/transfer?openid='+this.openid+'&elder='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {

                        this.elder_name = data.data.data.name;
                        this.stationSlots[0].values = data.data.station;

                    } else {
                        this.$toast(data.data.message);
                    }
                });
        }



    }
</script>


// WEBPACK FOOTER //
// src/pages/elder/transfer.vue